module.exports = __webpack_public_path__ + "img/faqseal_pic3.77d9ede0.png";